export default __webpack_public_path__ + "static/start-logo-social-d55ce048016517ef39c3269c0330b217.jpg";